export default __webpack_public_path__ + "assets/images/dfdd4ce466d734716a90e317df7b34d5.svg";